import React, { FC, useEffect } from 'react'
import { adsenseConfig } from './adsenseConfig'
import classNames from 'classnames'
import { DEVELOPMENT } from '../../env'

declare global {
  interface Window {
    adsbygoogle: any[] | undefined
  }
}

export interface AdsenseProps {
  slot: string
  channel?: string
  layout?: string
}

export const Adsense: FC<
  AdsenseProps & {
    className?: string
  }
> = ({ slot, layout, channel, className }) => {
  useEffect(() => {
    checkScript()
    initAdSlot()
  }, [])

  return (
    <ins
      className={classNames('adsbygoogle block', className)}
      data-ad-client={adsenseConfig.client}
      data-ad-slot={slot}
      data-ad-layout={layout}
      data-ad-channel={channel}
      data-full-width-responsive="false"
      data-adtest={DEVELOPMENT ? 'on' : 'off'}
    />
  )
}

function initAdSlot() {
  ;(window.adsbygoogle = window.adsbygoogle || []).push({})
}

function checkScript() {
  const src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adsenseConfig.client}`

  if (isScriptMissing(src)) {
    appendScript(createScript(src))
  }
}

function isScriptMissing(src: string) {
  return window.document.querySelector(`script[src="${src}"]`) === null
}

function createScript(src: string) {
  const script = document.createElement('script')
  script.src = src
  script.crossOrigin = 'anonymous'
  script.async = true
  return script
}

function appendScript(script: HTMLScriptElement) {
  window.document.getElementsByTagName('head')[0].appendChild(script)
}
